import {FC} from "react"
import {BlockType, MarkdownAtom, MarkdownBlock} from "../model/markdown/MarkdownText"
import {MarkdownCode} from "./blocks/MarkdownCode"
import {MarkdownHeaderBlock} from "./blocks/MarkdownHeaderBlock"
import {MarkdownOrderedList} from "./blocks/MarkdownOrderedList"
import {MarkdownParagraph} from "./blocks/MarkdownParagraph"
import {MarkdownQuote} from "./blocks/MarkdownQuote"
import {MarkdownTable} from "./blocks/MarkdownTable"
import {MarkdownUnorderedList} from "./blocks/MarkdownUnorderedList"

interface Props {
    block: MarkdownBlock
    onToggleCheckBox: (atom: MarkdownAtom) => void
}

export const MarkdownBlockRenderer: FC<Props> = ({
                                                     block,
                                                     onToggleCheckBox,
                                                 }) => {
    switch (block.type) {
        case BlockType.HEADER_1:
        case BlockType.HEADER_2:
        case BlockType.HEADER_3:
        case BlockType.HEADER_4:
        case BlockType.HEADER_5:
        case BlockType.HEADER_6:
            return (
                <MarkdownHeaderBlock block={block} onToggleCheckBox={onToggleCheckBox}/>
            )
        case BlockType.PARAGRAPH:
            return (
                <MarkdownParagraph block={block} onToggleCheckBox={onToggleCheckBox}/>
            )
        case BlockType.CODE:
            return (
                <MarkdownCode block={block} onToggleCheckBox={onToggleCheckBox}/>
            )
        case BlockType.QUOTE:
            return (
                <MarkdownQuote block={block} onToggleCheckBox={onToggleCheckBox}/>
            )
        case BlockType.ORDERED_LIST:
            return (
                <MarkdownOrderedList block={block} onToggleCheckBox={onToggleCheckBox}/>
            )
        case BlockType.UNORDERED_LIST:
            return (
                <MarkdownUnorderedList block={block} onToggleCheckBox={onToggleCheckBox}/>
            )
        case BlockType.TABLE:
            return (
                <MarkdownTable block={block} onToggleCheckBox={onToggleCheckBox}/>
            )
    }

    return (
        <div className="markdownBlock">Unknown block</div>
    )
}
